import React from "react";

export interface FormHeadingProps {
    heading: string | undefined;
}

export const FormHeading = ({ heading }: FormHeadingProps) => 
    <h3 className="text-brand-primary-20 text-xl font-bold leading-tight lg:text-3.5xl">{heading}</h3>;